import { action as apiAction } from 'api/Api'
import { pushCard } from 'index'
import sweetalert from 'sweetalert2'

type Payload = {
  cardId: number
  name: string
  position?: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, name } = payload

  const state = getState()

  const boardId = state['view-board'].cards[cardId].boardId

  try {
    const { Card } = await apiAction('AddCard', {
      template: { type: 'card', id: cardId },
      boardId,
      name: name.trim(),
      isTemplate: true
    })

    dispatch(pushCard(Card.Id))
  } catch (error) {
    if (error.code === 543) { // KanBo Exception: Board has no default status
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['CARD_ADD_NO_DEFAULT_STATUS'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
